module.exports = __webpack_public_path__ + "7a36cb6cbd59db7f07a146d3acc7036b.png";